import React, { useState } from 'react';
import { BackLayout } from '../../../components/layouts/back/BackLayout';
import { Spinner } from '../../../components/shared/Spinner';
import { useGetAll } from '../../../core/hooks/firebase/useGetAll';
import { RESOURCES } from '../../../core/constants/resources';
import { useTranslation } from 'react-i18next';
import { AddButton } from '../../../components/shared/button/AddButton';
import { BACK } from '../../../core/constants/routes';
import { useNavigate } from 'react-router-dom';
import { DeleteModal } from '../../../components/shared/modal/DeleteModal';
import { save } from '../../../core/services/firebase/resources.service';
import { AwardResponse } from '../../../core/models/Award';
import { AwardCard } from '../../../components/back/card/AwardCard';

export const Awards = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [modalDelete, setModalDelete] = useState<AwardResponse | null>(null);

    const {
        data: awards,
        loading,
        mutation,
    } = useGetAll<AwardResponse, AwardResponse>({ resource: RESOURCES.AWARDS });

    if (loading) {
        return (
            <div className="vh-100">
                <Spinner />
            </div>
        );
    }

    const handleCardClick = (award: AwardResponse) => () => {
        navigate(BACK.AWARD_DETAIL(award.id));
    };

    const handleCardDelete = (award: AwardResponse) => () => {
        setModalDelete(award);
    };

    const submitDelete = () => {
        if (modalDelete) {
            save(RESOURCES.AWARDS, modalDelete.id, {
                ...modalDelete,
                deleted: true,
            });
            setModalDelete(null);
            mutation();
        }
    };

    return (
        <BackLayout>
            <AddButton floating onClick={() => navigate(BACK.AWARD_CREATE)} />
            {awards.map((award) => (
                <AwardCard
                    key={award.id}
                    award={award}
                    onClick={handleCardClick(award)}
                    onDelete={handleCardDelete(award)}
                />
            ))}
            <DeleteModal
                show={!!modalDelete}
                title={t('pages.back.awards.modal.delete.title')}
                onDelete={submitDelete}
                onClose={() => setModalDelete(null)}
            >
                <p>{t('pages.back.awards.modal.delete.message')}</p>
            </DeleteModal>
        </BackLayout>
    );
};
